/* Conde Hair — Pro Access pop-up trigger.
 *
 * Markup: sections/conde-pro-popup.liquid   Styles: assets/conde-pro-popup.css
 *
 * Launch rules:
 *   Page 1 of the session — N seconds of ACTIVE viewing AND M% of the page
 *     scrolled. Both, not either: a visitor who scans fast should not be
 *     interrupted the instant they cross 25%, and a tab parked in the
 *     background should not age into a pop-up on its own.
 *   Page 2 onward — a flat N seconds of active viewing, no scroll condition.
 *     This is the window the conversion studies he cited put highest, and it
 *     is the fallback whenever page 1's pair of conditions never both landed.
 *
 * "Active viewing" only accrues while document.visibilityState is 'visible',
 * which is what makes the background-tab case behave.
 */
(function () {
  "use strict";

  var root = document.querySelector("[data-conde-pro-popup]");
  if (!root) return;

  var SEEN_KEY = "conde_pro_popup_seen_at";
  var PAGE_KEY = "conde_pro_popup_page_count";
  var TICK_MS = 250;
  /* Mirrors --conde-duration-reveal, the card's transition in conde-pro-popup.css.
     Keep the two in step so `hidden` lands after the fade, not through it. */
  var FADE_MS = 600;

  function num(value, fallback) {
    var parsed = parseFloat(value);
    return isNaN(parsed) ? fallback : parsed;
  }

  var firstDelay = num(root.dataset.firstDelay, 12) * 1000;
  var firstScroll = num(root.dataset.firstScroll, 25);
  var laterDelay = num(root.dataset.laterDelay, 5) * 1000;
  var reappearDays = num(root.dataset.reappearDays, 30);

  /* Storage is wrapped because Safari private browsing throws on write, and a
     storage failure should degrade to "show the pop-up", never to a crash. */
  function readStore(store, key) {
    try {
      return window[store].getItem(key);
    } catch (e) {
      return null;
    }
  }

  function writeStore(store, key, value) {
    try {
      window[store].setItem(key, value);
    } catch (e) {
      /* no-op */
    }
  }

  function alreadySeen() {
    var seenAt = parseInt(readStore("localStorage", SEEN_KEY), 10);
    if (!seenAt) return false;
    return Date.now() - seenAt < reappearDays * 24 * 60 * 60 * 1000;
  }

  if (alreadySeen()) return;

  /* Page position within the session. Incremented once per page load, so the
     first page a visitor lands on is 1 regardless of which page it is. */
  var pageIndex = parseInt(readStore("sessionStorage", PAGE_KEY), 10) || 0;
  pageIndex += 1;
  writeStore("sessionStorage", PAGE_KEY, String(pageIndex));

  var isFirstPage = pageIndex === 1;
  var requiredMs = isFirstPage ? firstDelay : laterDelay;

  var card = root.querySelector(".conde-pp__card");
  var closeButton = root.querySelector("[data-conde-pp-close]");
  var scrim = root.querySelector("[data-conde-pp-scrim]");
  var image = root.querySelector(".conde-pp__image");

  /* The card ships hidden, so its lazy image would not begin downloading until
     the moment it is revealed, leaving a blank panel for the length of the
     fetch. Warming it fixes that, but warming it on page load would spend the
     download on every eligible visitor, and most bounce long before the
     pop-up ever fires. So it is deferred until someone is halfway to the
     trigger, which is early enough to land before the card appears and late
     enough that passers-by never pay for it. */
  var warmed = false;
  function warmImage() {
    if (warmed || !image) return;
    warmed = true;
    image.loading = "eager";
  }

  var activeMs = 0;
  var lastStamp = Date.now();
  var timer = null;
  var opened = false;
  var openedAt = null;
  var lastFocused = null;

  function scrollPercent() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    /* A page too short to scroll has, in effect, already been read in full. */
    if (scrollable <= 0) return 100;
    return (window.scrollY / scrollable) * 100;
  }

  function conditionsMet() {
    if (activeMs < requiredMs) return false;
    if (isFirstPage && scrollPercent() < firstScroll) return false;
    return true;
  }

  function tick() {
    var now = Date.now();
    if (document.visibilityState === "visible") {
      /* Clamp the delta so a laptop waking from sleep does not bank the
         whole nap as viewing time. */
      activeMs += Math.min(now - lastStamp, TICK_MS * 4);
    }
    lastStamp = now;
    if (activeMs >= requiredMs / 2) warmImage();
    if (conditionsMet()) open();
  }

  function focusables() {
    return Array.prototype.filter.call(
      card.querySelectorAll("a[href], button:not([disabled])"),
      function (el) {
        return el.offsetParent !== null;
      }
    );
  }

  function onKeydown(event) {
    if (event.key === "Escape") {
      close("escape");
      return;
    }
    if (event.key !== "Tab") return;

    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  /* PostHog is optional and loads async (snippets/conde-posthog.liquid only
     renders when tracking is enabled and a project key is set), so every call
     is guarded exactly the way conde-posthog.js guards its own. */
  function track(event, props) {
    if (!window.posthog || typeof window.posthog.capture !== "function") return;
    window.posthog.capture(
      event,
      Object.assign(
        {
          path: window.location.pathname,
          page_index: pageIndex,
          active_seconds: Math.round(activeMs / 100) / 10
        },
        props || {}
      )
    );
  }

  function open() {
    if (opened) return;
    opened = true;
    warmImage();
    window.clearInterval(timer);
    window.removeEventListener("scroll", onScroll);

    /* Read the depth BEFORE the scroll lock below, which changes what
       scrollPercent() reports. Reading it afterwards logs a number the
       visitor never actually reached. */
    var scrollAtOpen = Math.round(scrollPercent());

    /* Stamped on show rather than on dismiss so it cannot re-arm on the next
       page load of the same visit. */
    writeStore("localStorage", SEEN_KEY, String(Date.now()));

    lastFocused = document.activeElement;

    /* Lock the page without letting the vanishing scrollbar shift the layout. */
    var gutter = window.innerWidth - document.documentElement.clientWidth;
    if (gutter > 0) {
      document.documentElement.style.setProperty("padding-right", gutter + "px");
    }
    document.documentElement.classList.add("conde-pp-locked");

    root.removeAttribute("hidden");
    /* Next frame, so the browser has a painted "closed" state to animate from. */
    window.requestAnimationFrame(function () {
      root.classList.add("conde-pp--open");
    });

    document.addEventListener("keydown", onKeydown);
    if (closeButton) closeButton.focus();

    openedAt = Date.now();
    track("pro_popup_shown", {
      /* Which of the two launch rules actually fired, so the page-1 and
         page-2 windows can be compared against each other in PostHog. */
      trigger: isFirstPage ? "page_1_time_and_scroll" : "page_2_time",
      scroll_percent: scrollAtOpen
    });
  }

  function close(reason) {
    if (!opened) return;

    track("pro_popup_dismissed", {
      method: typeof reason === "string" ? reason : "unknown",
      seconds_open: openedAt ? Math.round((Date.now() - openedAt) / 100) / 10 : null
    });

    root.classList.remove("conde-pp--open");
    document.removeEventListener("keydown", onKeydown);
    document.documentElement.classList.remove("conde-pp-locked");
    document.documentElement.style.removeProperty("padding-right");

    window.setTimeout(function () {
      root.setAttribute("hidden", "");
    }, FADE_MS);

    if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
  }

  function onScroll() {
    if (conditionsMet()) open();
  }

  function onVisibility() {
    /* Reset the clock edge so the hidden stretch is not counted on return. */
    lastStamp = Date.now();
  }

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      close("close_button");
    });
  }
  if (scrim) {
    scrim.addEventListener("click", function () {
      close("scrim");
    });
  }

  /* Fires before the navigation starts. The pop-up is the last thing on the
     page at this point, so a plain capture is enough — no beacon needed. */
  Array.prototype.forEach.call(root.querySelectorAll(".conde-pp__btn"), function (btn) {
    btn.addEventListener("click", function () {
      track("pro_popup_cta_clicked", {
        cta: btn.classList.contains("conde-pp__btn--outline") ? "secondary" : "primary",
        label: (btn.textContent || "").trim(),
        href: btn.getAttribute("href"),
        seconds_open: openedAt ? Math.round((Date.now() - openedAt) / 100) / 10 : null
      });
    });
  });

  document.addEventListener("visibilitychange", onVisibility);
  window.addEventListener("scroll", onScroll, { passive: true });

  timer = window.setInterval(tick, TICK_MS);
})();
